import React from 'react'
import { FormattedMessage } from 'react-intl'
 import css from "./HowDoesItWork.module.css"
export default function HowDoesItWork() {
  return (
     <>
     <div className={css.BusinessOwnerWrap}>
     <div className={css.HowDoesItWorkMain}>
        <p className={css.heading} > <FormattedMessage id='HowDoesItWork.heading'/></p>
        <p className={css.subheading} ><FormattedMessage id='HowDoesItWork.subHeading'/></p>
        <div className={css.HowDoesItWorkContainer1}>
            <div className={css. boxItem}>
               
                <div className={css.boxItemDescContainer}>
                    <h3 className={css.title} ><FormattedMessage id='HowDoesItWork.title1'/></h3>
                    <p className={css.about}><FormattedMessage id='HowDoesItWork.about1'/> </p>
                </div>
            </div>
            <div className={css. boxItem}>
            
                <div className={css.boxItemDescContainer}>
                    <h3 className={css.title} > <FormattedMessage id='HowDoesItWork.title2'/></h3>
                    <p className={css.about}><FormattedMessage id='HowDoesItWork.about2'/> </p>
                </div>
            </div>
            <div className={css. boxItem}>
            
                <div className={css.boxItemDescContainer}>
                    <h3 className={css.title} > <FormattedMessage id='HowDoesItWork.title3'/></h3>
                    <p className={css.about}><FormattedMessage id='HowDoesItWork.about3'/> </p>
                </div>
            </div>
        </div>
 
            


    </div>
    </div>
     </>
  )
}
